var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "default-modal",
    {
      attrs: {
        name: "tfa-modal",
        title: _vm.$t("backup_codes"),
        actionLabel: _vm.$t("regenerate_codes"),
        successHandler: _vm.handleRegenerate
      },
      model: {
        value: _vm.modalOpened,
        callback: function($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened"
      }
    },
    [
      _c(
        "template",
        { slot: "content" },
        [
          _c("p", {
            domProps: { innerHTML: _vm._s(_vm.$t("backup_codes_body")) }
          }),
          _c("backup-codes-area", {
            staticClass: "q-mt-lg q-mb-sm",
            attrs: { "backup-codes": _vm.backupCodes }
          }),
          _c("q-inner-loading", { attrs: { visible: _vm.loading } })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }